'use strict';

/**
 * A reference is an address inside the caches - for either an
 * instance of data (`DataReference`) or the result of a request
 * (`RequestReference`). All references can be used as strings which
 * will uniquely identify the address.
 *
 * Do not instantiate this class or its subclasses directly. Use the
 * `reference()` helper instead.
 */
module.exports = class Reference {
};



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/storage/Reference.js